module.exports = __webpack_public_path__ + "media/brands/aston martin-839f5bab.png";